import React, { useState } from "react";
import { Dropdown, Space, Button } from "antd";
import {
  SortAscendingOutlined,
  SortDescendingOutlined,
} from "@ant-design/icons";

import "./LexicalSort.scss";

function LexicalSort({ globalFilterData, setGlobalFilterData }) {
  const [sortOrder, setSortOrder] = useState("");
  const [sortKey, setSortKey] = useState("");
  const items = [
    { label: "Resume ID", key: "qhrid" },
    { label: "Name", key: "name" },
    { label: "Current Location", key: "location" },
    { label: "Overall Update Time", key: "overallUpdateTime" },
    { label: "Candidate Status Update Time", key: "candidateStatusUpdateTime" },
    { label: "Resume Status Update Time", key: "resumeStatusUpdateTime" },
    { label: "Interview Status Update Time", key: "interviewStatusUpdateTime" },
    { label: "Sourcing Time", key: "sourcingTime" },
    { label: "Selection Status Update Time", key: "selectionStatusUpdateTime" },
    { label: "Skill Analysis", key: "skillAnalysis" },
    { label: "Role Analysis", key: "roleAnalysis" },
    { type: "divider" },
    {
      label: "Ascending",
      key: "ascending",
      icon: <SortAscendingOutlined />,
      disabled: sortOrder === "ascending",
    },
    {
      label: "Descending",
      key: "descending",
      icon: <SortDescendingOutlined />,
      disabled: sortOrder === "descending",
    },
  ];
  const currentItem = items.find((item) => item.key === sortKey);
  const displayLabel = currentItem ? currentItem.label : sortKey;
  const menuProps = {
    items,
    onClick: ({ key }) => {
      if (["ascending", "descending"].includes(key)) {
        setSortOrder(key);
        setGlobalFilterData({
          ...globalFilterData,
          sortOrder: key,
          sortBy: sortKey,
        });
      } else {
        handleSortClick(key);
      }
    },
    selectedKeys: [sortKey, sortOrder],
  };

  const handleSortClick = (key) => {
    const newOrder =
      key === sortKey
        ? sortOrder === "ascending"
          ? "descending"
          : "ascending"
        : "ascending";
    setGlobalFilterData({
      ...globalFilterData,
      sortOrder: newOrder,
      sortBy: key,
    });

    setSortKey(key);
    setSortOrder(newOrder);
  };

  return (
    <div className="resumes-sort-wrapper">
      <Dropdown menu={menuProps} trigger={["click"]}>
        <Button className="sideFont">
          <Space>
            {sortOrder === "ascending" ? (
              <SortAscendingOutlined />
            ) : (
              <SortDescendingOutlined />
            )}
            Sort: {displayLabel}
          </Space>
        </Button>
      </Dropdown>
    </div>
  );
}

export default LexicalSort;
